import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { PaypalSuccessComponent } from './paypal-success.component';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('registration.paypal-success', {
            url: '/paypal-success',
            data: {
                authorisationLevel: 0,
                pageTitle: 'Registration Paypal'
            },
            'views': {
                'multiContentRegistration': {
                    template: '<paypal-success flex="100"></paypal-success>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const PaypalSuccessModule: string = ng
    .module('paypal-success', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('paypalSuccess', PaypalSuccessComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/paypal-success/paypal-success.module.ts